import React, { Component } from "react"
import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"
import {
  Segment,
  Grid,
  Image,
  Icon,
  Button,
  Container
} from "semantic-ui-react"

import { Icon as IconKit } from "react-icons-kit"
import { hammer } from "react-icons-kit/ionicons/hammer"
import { hand } from "react-icons-kit/entypo/hand"
import "./MateriauxComponent.css"
import BandeauNoir from "../Entete/BandeauNoir"
import RechercheFiltre from "../Entete/RechercheFiltre"
import BouttonEntete from "../Entete/BouttonEntete"
import { cogOutline as matsIcon } from "react-icons-kit/typicons/cogOutline"
import ModalMateriaux from "./ModalMateriaux"
import _ from "lodash"
import ModalEditMateriau from "./ModalEditMateriau"
import MateriauxService from "./MateriauxService"

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedMateriauxComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      materiauData: [],
      filters: {
        materials: true,
        workforce: true,
        work: true
      },
      sortOptions: {
        sortType: undefined,
        sortDirection: "ASC"
      },
      editModalOpen: false,
      currentEditRow: {}
    }

    this.handleFilter = this.handleFilter.bind(this)
    this.handleSort = this.handleSort.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleCopy = this.handleCopy.bind(this)
  }

  componentWillMount() {
    MateriauxService.getData(this.props.app.token)
      .then(data => {
        console.log("Aggregation data : ", data)
        this.setState({
          materiauData: data
        })
      })
      .catch(err => {
        alert(err)
      })
  }

  handleSearchChange(e, data) {
    var materiauData = data.value
    this.setState({
      materiauData
    })
  }

  handleUpdateRow = row => {
    console.log("Row to save", row)
    if (row.type == "workforce") {
      let workforceData = {
        name_manually: row["name"],
        spht: row.price,
        unit: row["unité"],
        id: row.id
      }
      MateriauxService.updateWorforce(this.props.app.token, workforceData)
        .then(res => {
          console.log("Res ?", res)
          var tabCopy = MateriauxService.edit(this.state.materiauData, row)
          this.setState({
            materiauData: tabCopy
          })
        })
        .catch(err => {
          alert(err)
        })
    }
    if (row.type == "work") {
      let workData = {
        name_manually: row["name"],

        spht: row.price,
        unit: row["unité"],
        id: row.id
      }
      MateriauxService.updateWorks(this.props.app.token, workData)
        .then(res => {
          console.log("Res ?", res)
          var tabCopy = MateriauxService.edit(this.state.materiauData, row)
          this.setState({
            materiauData: tabCopy
          })
        })
        .catch(err => {
          alert(err)
        })
    }
  }

  handleCopy(clientData, index) {
    var tabCopy = _.clone(this.state.materiauData)
    tabCopy.splice(index, 0, {
      ...clientData,
      id: tabCopy.length + 1
      //TODO implement id handling
      // We should have a generated id here by the database,
      // Should replace tabCopy.length +1 by the "id" in the query response when duplicating
    })
    this.setState({
      materiauData: tabCopy
    })
  }
  // create data
  handleSave(clientData) {
    if (clientData.toggle == 2) {
      // Workforce
      let workforceData = {
        name_manually: clientData["name"],
        fkuidcountry: 50,
        spht: clientData.price,
        unit: clientData["unité"]
      }
      console.log(clientData, workforceData)
      MateriauxService.createWorforce(this.props.app.token, workforceData)
        .then(res => {
          var tabCopy = this.state.materiauData
          tabCopy.push({
            ...clientData,
            type:
              clientData.toggle === 1
                ? "materials"
                : clientData.toggle === 2
                  ? "workforce"
                  : "work"
          })
          this.setState({
            materiauData: tabCopy
          })
        })
        .catch(err => {
          alert(err)
        })
    }
    if (clientData.toggle == 3) {
      // Work
      let workData = {
        name_manually: clientData["name"],
        fkuidcountry: 50,
        spht: clientData.price,
        unit: clientData["unité"]
      }
      console.log(clientData, workData)
      MateriauxService.createWorks(this.props.app.token, workData)
        .then(res => {
          var tabCopy = this.state.materiauData
          tabCopy.push({
            ...clientData,
            type:
              clientData.toggle === 1
                ? "materials"
                : clientData.toggle === 2
                  ? "workforce"
                  : "work"
          })
          this.setState({
            materiauData: tabCopy
          })
        })
        .catch(err => {
          alert(err)
        })
    }
  }

  handleFilter(rowType) {
    var newFilterValue = this.state.filters
    newFilterValue[rowType] = !this.state.filters[rowType]
    this.setState({ filters: newFilterValue })
  }

  handleSort(columnType) {
    var sortOptions = this.state.sortOptions || {}
    if (columnType === sortOptions.sortType) {
      if (sortOptions.sortDirection === MateriauxService.ASC) {
        sortOptions.sortDirection = MateriauxService.DESC
      } else {
        sortOptions.sortDirection = MateriauxService.ASC
      }
    } else {
      sortOptions.sortType = columnType
      sortOptions.sortDirection = MateriauxService.ASC
    }
    this.setState({ sortOptions })
  }

  // Delete
  handleDelete(idx, row) {
    if (row.type == "workforce") {
      MateriauxService.deleteWorforce(this.props.app.token, {
        id: row.id
      })
        .then(res => {
          var tabCopy = this.state.materiauData
          tabCopy.splice(row, 1)
          this.setState({ materiauData: tabCopy })
        })
        .catch(err => {
          alert(err)
        })
    }
    if (row.type == "work") {
      MateriauxService.deleteWorks(this.props.app.token, {
        id: row.id
      })
        .then(res => {
          console.log("Delete res?", res)
          var tabCopy = this.state.materiauData
          tabCopy.splice(idx, 1)
          this.setState({ materiauData: tabCopy })
        })
        .catch(err => {
          alert(err)
        })
    }
  }

  handleSearchChangeFilter = (e, val) => {
    this.setState({
      searchValue: val.value
    })
  }

  handleOpenEditModal = row => {
    this.setState({
      editModalOpen: true,
      currentEditRow: row
    })
  }

  handleCloseEditModal = () => {
    this.setState({ editModalOpen: false, currentEditRow: {} })
  }

  render() {
    let { t } = this.props
    this.state.filters, this.state.materiauData, this.state.clientData

    return (
      <Segment id="main">
        <BandeauNoir icon={matsIcon} category={t("category_title")}>
          <BouttonEntete
            text={t("add_btn_text")}
            style="bouttonEntete1"
            iconName="file outline plus"
          />

          <ModalMateriaux onSave={data => this.handleSave(data)} />
          <ModalEditMateriau
            open={this.state.editModalOpen}
            materials={this.state.materiauData}
            row={this.state.currentEditRow}
            handleClose={this.handleCloseEditModal}
            onSave={dataCol => {
              this.handleUpdateRow(dataCol)
            }}
          />
          <BouttonEntete
            text={t("import_btn_text")}
            style="bouttonEntete2"
            iconName="download"
          />
        </BandeauNoir>
        <RechercheFiltre
          onSearchChange={this.handleSearchChangeFilter}
          prestations={t("prestations_text")}
          style={{ padding: "20px 0", margin: "0 18px" }}
        />
        <Segment id="containerButton">
          <Container id="filterLabel">{t("display_label")}</Container>
          <Button
            className="filterBtn"
            active={this.state.filters[MateriauxService.MATERIALS_TYPE]}
            onClick={() => this.handleFilter(MateriauxService.MATERIALS_TYPE)}
          >
            {t("mats_btn_label")}
          </Button>
          <Button
            className="filterBtn"
            active={this.state.filters[MateriauxService.WORKFORCE_TYPE]}
            onClick={() => this.handleFilter(MateriauxService.WORKFORCE_TYPE)}
          >
            {t("workforce_btn_label")}
          </Button>
          <Button
            className="filterBtn"
            active={this.state.filters[MateriauxService.WORK_TYPE]}
            onClick={() => this.handleFilter(MateriauxService.WORK_TYPE)}
          >
            {t("work_btn_label")}
          </Button>
        </Segment>
        <Segment id="matGrid">
          <Grid columns="equal">
            <Grid.Row className="matHeader">
              <Grid.Column computer={4} tablet={4} mobile={16}>
                {t("firstCol_label")}
                <Icon
                  id="IconSortDisplay"
                  onClick={() => this.handleSort(MateriauxService.SORT_BY_NAME)}
                  size="small"
                  name="sort"
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={4} mobile={16}>
                {t("secondCol_label")}
                <Icon
                  id="IconSortDisplay"
                  onClick={() =>
                    this.handleSort(MateriauxService.SORT_BY_PRICE)
                  }
                  size="small"
                  name="sort"
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={4} mobile={16}>
                {t("thirdCol_label")}
                <Icon
                  id="IconSortDisplay"
                  onClick={() =>
                    this.handleSort(MateriauxService.SORT_BY_BILLING_PRICE)
                  }
                  size="small"
                  name="sort"
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={4} mobile={16}>{t("actions_label")}</Grid.Column>
            </Grid.Row>
            {_.map(
              MateriauxService.getDisplayedList(
                this.state.materiauData,
                this.state.filters,
                this.state.sortOptions,
                this.state.searchValue
              ),
              (matRow, index) => {
                return (
                  <Grid.Row className="matRow" key={matRow.id}>
                    <Grid.Column verticalAlign="middle" width={8}>
                      {matRow.type === MateriauxService.MATERIALS_TYPE ? (
                        <IconKit className="matRowIcon" icon={hammer} />
                      ) : matRow.type === MateriauxService.WORKFORCE_TYPE ? (
                        <IconKit className="matRowIcon" icon={hand} />
                      ) : (
                        <Image
                          className="matRowIcon"
                          src="https://image.flaticon.com/icons/svg/64/64978.svg"
                        />
                      )}
                      {matRow.name +
                        (matRow.reference ? "\tRef." + matRow.reference : "")}
                    </Grid.Column>
                    <Grid.Column verticalAlign="middle">
                      {matRow.basePrice ? matRow.basePrice + "!ù!ù! €" : "-"}
                    </Grid.Column>
                    <Grid.Column verticalAlign="middle" className="priceCol">
                      {matRow.price ? matRow.price + " €" : "-"}
                    </Grid.Column>
                    <Grid.Column verticalAlign="middle">
                      <Icon
                        onClick={() => this.handleOpenEditModal(matRow)}
                        circular
                        name="pencil"
                        color="green"
                        className="actionIcon"
                        size="medium"
                      />
                      <Icon
                        id="actionIcon"
                        circular
                        name="copy outline"
                        color="teal"
                        className="actionIcon"
                        onClick={() => {
                          this.handleCopy(matRow, index)
                        }}
                      />
                      <Icon
                        circular
                        name="trash alternate"
                        color="red"
                        className="actionIcon"
                        onClick={() => {
                          this.handleDelete(index, matRow)
                        }}
                      />
                    </Grid.Column>
                  </Grid.Row>
                )
              }
            )}
          </Grid>
        </Segment>
      </Segment>
    )
  }
}

const MateriauxComponent = connect(mapStateToProps)(ConnectedMateriauxComponent)
export default translate("MateriauxComponent")(MateriauxComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/Materiaux/MateriauxComponent.jsx